import type { DocumentRevision, RevisionByIdResponse } from '@/entities/Document';

const DEFAULT_EDIT_DOCUMENT_MODAL_TITLE = 'Editar/Configurar Documento';

export function resolveEditDocumentModalTitle(attrs: Record<string, unknown>): string {
  return typeof attrs.title === 'string' ? attrs.title : DEFAULT_EDIT_DOCUMENT_MODAL_TITLE;
}

export function mergeRevisionWithFetchedForEditModal(
  revision: DocumentRevision,
  fetched: RevisionByIdResponse,
  variant: 'internal' | 'external'
): DocumentRevision {
  return {
    ...revision,
    status: fetched.status,
    validityDate: fetched.validityDate ?? revision.validityDate,
    ...(variant === 'external'
      ? { externalRevision: fetched.externalRevision ?? revision.externalRevision }
      : {}),
    config: fetched.config ? { ...revision.config, ...fetched.config } : revision.config,
    physicalLocations: fetched.physicalLocations ?? revision.physicalLocations,
    notifications: fetched.notifications ?? revision.notifications,
  };
}

export function mapEditDocumentModalAttrs(
  revision: DocumentRevision,
  attrs: Record<string, unknown>,
  fetched: RevisionByIdResponse,
  variant: 'internal' | 'external'
): { title: string; revision: DocumentRevision } {
  return {
    title: resolveEditDocumentModalTitle(attrs),
    revision: mergeRevisionWithFetchedForEditModal(revision, fetched, variant),
  };
}
